/*
 * File: auto-card.ts
 * File Created: 2024-01-24 02:31:13
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:30:32
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import Card from "../card/card";
import { MixinAuto } from "@root/components/base-classes";

@Component({
    mixins: [MixinAuto],
})
export default class AutoCard extends Card {}
